import React, { Children } from "react"
import PropTypes from "prop-types"

import { areAllSwitch, uniqueValues } from "./validate.js"
import styles from "./content-switcher.module.css"

const validateSwitch = (children) => {
  const count = Children.count(children)
  const childrenArr = Children.toArray(children)

  if (!areAllSwitch(childrenArr)) {
    console.warn(
      "ContentSwitcher: All children in <ContentSwitcher> should be a <Switch>"
    )
    return false
  }

  if (!uniqueValues(childrenArr, count)) {
    console.warn(
      "ContentSwitcher: `value` should be unique among all <Switch> elements"
    )
    return false
  }

  return true
}

export const ContentSwitcher = ({ children, ...props }) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  if (!validateSwitch(children)) {
    return null
  }
  return (
    <div {...rest} className={styles.Contentswitcher} role="tablist">
      {children}
    </div>
  )
}

ContentSwitcher.displayName = "ContentSwitcher"

ContentSwitcher.propTypes = {
  /**
   * Switch components.
   */
  children: PropTypes.node.isRequired,
}
